export const APP_VERSION = '11cd925';
